export default __webpack_public_path__ + "static/media/cameraOff.70f16345.svg";